import * as React from 'react'
import { ThemeProvider } from 'styled-components'
import Helmet from 'react-helmet'
import Root from '../../components/Root'
import Header from '../../components/Header'
import Footer from '../../components/Footer'

import theme from '../../styles/theme'
import 'normalize.css'
import './index.css'

import { IntlProvider } from 'react-intl'

export interface LayoutProps {
  locale: string
  messages: { [id: string]: string }
  children: () => React.ReactNode
}

const LayoutTemplate: React.SFC<LayoutProps> = ({ locale, messages, children }) => {
  return (
    <IntlProvider locale={locale} key={locale} messages={messages} textComponent={React.Fragment}>
      <ThemeProvider theme={{ mode: 'light', ...theme }}>
        <Root>
          <Helmet htmlAttributes={{ lang: locale }}>
            <title>Steadio — Sign in — Tumblbug</title>
          </Helmet>
          <Header isDumb={true} />
          <main>{children()}</main>
          <Footer />
        </Root>
      </ThemeProvider>
    </IntlProvider>
  )
}

export default LayoutTemplate



// WEBPACK FOOTER //
// ./src/templates/Layout/index.tsx